import { useEffect } from "react";


interface UseEditorKeyboardShortcutsOptions {
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
}


export function useEditorKeyboardShortcuts({
  onUndo,
  onRedo,
  canUndo,
  canRedo,
}: UseEditorKeyboardShortcutsOptions) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check if Cmd (Mac) or Ctrl (Windows/Linux) is pressed
      const isCmdOrCtrl = event.metaKey || event.ctrlKey;

      if (!isCmdOrCtrl) {
        return;
      }

      // Cmd/Ctrl + Z (Undo)
      if (event.key === "z" && !event.shiftKey && canUndo) {
        event.preventDefault();
        onUndo();
        return;
      }

      // Cmd/Ctrl + Shift + Z (Redo)
      if (event.key === "z" && event.shiftKey && canRedo) {
        event.preventDefault();
        onRedo();
        return;
      }

      // Cmd/Ctrl + Y (Redo - alternative)
      if (event.key === "y" && canRedo) {
        event.preventDefault();
        onRedo();
        return;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onUndo, onRedo, canUndo, canRedo]);
}
